/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-20 13:50:23
 * @LastEditTime: 2020-12-09 13:47:07
 * @FilePath: \ensurance-front\src\utils\auth.js
 */
// import Cookies from 'js-cookie'
const userToken = 'userToken'
const refreshToken = 'refreshToken'
const userRoles = 'userroles'
// 设置用户信息
export function setUser(user) {
  // Cookies.set(userToken, user)
  window.sessionStorage.setItem(userToken, user)
}
// 获取用户信息
export function getUser() {
  // Cookies.get(userToken)
  return window.sessionStorage.getItem(userToken)
}
// 获取用户信息
export function getUserRoles() {
  // Cookies.get(userToken)
  return window.sessionStorage.getItem(userRoles)
}
// 删除用户信息
export function delUser() {
  window.sessionStorage.removeItem(userToken)
  // Cookies.remove(userToken)
}

// 获取refreshToken
export function getRefreshToken() {
  return window.localStorage.getItem(refreshToken)
}

// 设置refreshToken
export function setRefreshToken(refreshTokenValue) {
  window.localStorage.setItem(refreshToken, refreshTokenValue)
}
export function setUserRoles(userRoles) {
  window.localStorage.setItem(userRoles, userRoles)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js